import { typesofUsers } from "../../../config";

const SUBMITTABLE_SUBSCRIBER_ROLES = new Set([
  typesofUsers.subscriberUser,
  typesofUsers.subscriberAdmin,
  typesofUsers.agent,
  typesofUsers.manager,
  typesofUsers.admin,
  typesofUsers.superAdmin,
  typesofUsers.docuverusSuperAdmin,
]);

const SUBMITTABLE_APPLICATION_STATUSES = new Set([
  "Application In Progress",
  "In Progress",
]);

const normalizeApplicationType = (applicationType: unknown): string =>
  typeof applicationType === "string"
    ? applicationType.trim().toLowerCase().replace(/[^a-z]/g, "")
    : "";

export const canSubmitSubscriberApplication = (
  applicationType: unknown,
  applicationStatus: unknown,
  userRole: unknown,
  isDocUploadView = false
): boolean =>
  (normalizeApplicationType(applicationType) === "docupload" ||
    (applicationType === undefined || applicationType === null) && isDocUploadView) &&
  typeof userRole === "string" &&
  typeof applicationStatus === "string" &&
  SUBMITTABLE_SUBSCRIBER_ROLES.has(userRole) &&
  SUBMITTABLE_APPLICATION_STATUSES.has(applicationStatus);
